import React from "react";
import PropTypes from 'prop-types';
import { TextInput } from "../../../Helpers/Inputs";
import { Row } from 'react-bootstrap';

export default function MovingViolationForm(props) {

  const onFieldChange = (field, value) => {
    props.onChange({ ...props.formState, [field]: value })
  }

  return (
    <div key={props.index}>
      Conviction {props.index + 1}
      <Row className="m-0">
        <TextInput
          name={`movingViolationsOrRecklessDrivingConvictions[${props.index}].month`}
          id={`movingViolationsOrRecklessDrivingConvictions[${props.index}].month`}
          aria-label="Month"
          label="Month"
          value={props.formState.month}
          onChange={e => onFieldChange('month', e.target.value)}
          fullWidth={false}
        />
            &nbsp;
        <TextInput
          name={`movingViolationsOrRecklessDrivingConvictions[${props.index}].year`}
          id={`movingViolationsOrRecklessDrivingConvictions[${props.index}].year`}
          aria-label="Year"
          label="Year"
          value={props.formState.year}
          onChange={e => onFieldChange('year', e.target.value)}
          fullWidth={false}
        />
      </Row>
    </div>
  )
}

MovingViolationForm.propTypes = {
  formState: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
}
